export const SEATSIOCONFIG = {
  cursorTooltip: {
    showActionHint: true,
    showAvailability: true,
    showCategory: true,
    showLabel: true,
    showPricing: true,
    showUnavailableNotice: true,
    stylizedLabel: true
  },
  holdOnSelect: true,
  holdOnSelectForGAs: true,
  mobileTooltip: {
    showAvailability: true,
    showCategory: true,
    showPricing: true
  },
  colorScheme: 'dark',
  colors: {
    'theme-cursor-tooltip-background-color': '#252525',
    'theme-color-selected': '#2effec'
  },
  showRowLines: true,
  objectWithoutPricingSelectable: false,
  objectWithoutCategorySelectable: false,
  loading: `<div class="loader-inner line-scale-party mAuto">
    <div></div> <div></div> <div></div> <div></div></div>`
}
